/* eslint-disable import/prefer-default-export */

export const breakpoints = {
  desktop: 1260,
  tablet: 1024,
  tabletPortrait: 768,
};

export const keyboardKeyCodes = {
  arrowDown: 40,
  arrowUp: 38,
  return: 13,
};
